import * as Constants from "../../constants/Constants";
import { httpGetConfigValues } from "../../service/httpClient";
export const isBloomingdalesMerchantEmail = (
  primaryMerchantEmail,
  merchandiseType
) => {
  const isConsignementVendor =
    merchandiseType === Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT;
  const isVendorEligible = primaryMerchantEmail?.endsWith(
    Constants.BLOOMINGDALES_EMAIL_DOMAIN
  );
  return isConsignementVendor && isVendorEligible;
};

export const getMacyDept = (hierarchyDetails) => {
  let dept = "";
  if (hierarchyDetails?.length > 0) {
    hierarchyDetails.forEach((h) => {
      if (h.operatingDivision?.toLowerCase().indexOf("macy") > -1) {
        dept = dept.concat(h.dept).concat(",");
      }
    });
    return dept.substring(0, dept.length - 1);
  }
};

export const getBlmDept = (hierarchyDetails) => {
  let dept = "";
  if (hierarchyDetails?.length > 0) {
    hierarchyDetails.forEach((h) => {
      if (h.operatingDivision?.toLowerCase().indexOf("bloom") > -1) {
        dept = dept.concat(h.dept).concat(",");
      }
    });
    return dept.substring(0, dept.length - 1);
  }
};

export const getDisableEnableConfig = (keyValue, callback) => {
  httpGetConfigValues().then((response) => {
    if (response?.data) {
      Object.values(response.data)
        .filter((res) => res?.key.indexOf(keyValue) > -1)
        .map((val) => {
          callback(val?.value);
        });
    }
  });
};

export const verifyIfCheckedUnchecked = (fieldAttr, dbVal) => {
  return (Array.isArray(dbVal) && dbVal.includes(fieldAttr)) ||
    fieldAttr == dbVal
    ? "checked"
    : "un-checked";
};

export const formatPhone = (phoneNumber) => {
  let num = phoneNumber?.replace(/\D/g, "");
  if (num && num.length === 10) {
    let pn =
      "(" + num.slice(0, 3) + ") " + num.slice(3, 6) + "-" + num.slice(6);
    return pn === "()-" ? "" : pn;
  } else {
    return num || "";
  }
};

export const transformValue = (value) => {
  return value === "$" ? "000" : value;
};

export const getMultiSelectOptions = (fieldId, configValues) => {
  const configVal = configValues?.filter((config) => config.key === fieldId);
  const selectOptions = JSON.parse(configVal?.length > 0 && configVal[0].value);
  return selectOptions?.length > 0
    ? selectOptions.map((item) => ({
        value: item.name,
        label: item.value,
      }))
    : [];
};

export const getMultiSelectValue = (fieldId, dbValues, configValues) => {
  const configVal = configValues.filter((config) => config.key === fieldId);
  const selectOptions = JSON.parse(configVal?.length > 0 && configVal[0].value);
  let tempOpt = [];
  if (dbValues?.[fieldId]?.length > 0 && configValues?.length > 0) {
    tempOpt = selectOptions.filter((o) => {
      return (dbValues?.[fieldId]).split("|").some((val) => o.name === val);
    });
    tempOpt = tempOpt.map((val) => {
      let selectedObj = {
        label: val["value"],
        value: val["name"],
      };
      return selectedObj;
    });
  }
  return tempOpt;
};

export const isValidateDateField = (selectedDate, maxAllowedYear) => {
  selectedDate = new Date(selectedDate);
  const selectedDt =
    selectedDate.getDate() +
    selectedDate.getMonth() +
    selectedDate.getFullYear();

  maxAllowedYear = maxAllowedYear ? maxAllowedYear : 200;

  const currentDate = new Date();
  const currentDt =
    currentDate.getDate() + currentDate.getMonth() + currentDate.getFullYear();

  let maxAllowedDate =
    new Date().getDate() +
    new Date().getMonth() +
    new Date().setFullYear(new Date().getFullYear() + maxAllowedYear);

  if (
    selectedDate !== "Invalid Date" &&
    currentDt !== selectedDt &&
    (isNaN(selectedDate) ||
      selectedDate.getTime() < currentDate.getTime() ||
      selectedDate.getTime() > maxAllowedDate)
  ) {
    return false;
  } else {
    return true;
  }
};

export const getSelectedOptReactSelectFromConfig = (
  fieldId,
  dbValue,
  configValues
) => {
  const configVal = configValues.filter((config) => config.key === fieldId);
  const selectOptions = JSON.parse(configVal?.length > 0 && configVal[0].value);
  let tempOpt = [];
  if (dbValue?.[fieldId] && configValues?.length > 0) {
    tempOpt = selectOptions.filter((o) => {
      return o.name === dbValue?.[fieldId];
    });
    tempOpt = tempOpt.map((val) => {
      let selectedObj = {
        label: val["value"],
        value: val["name"],
      };
      return selectedObj;
    });
  }
  return tempOpt;
};
